const animationSpeed = 300;

function getTabOverflowItems(container) {
	const tabs = container.querySelector('.nav-tabs');
	if (!tabs) return { tabs: null, items: [], tabItems: [] };

	const items = [...tabs.children].filter((item) => item.classList.contains('nav-item'));
	return {
		tabs,
		items,
		tabItems: items.filter(
			(item) => !item.classList.contains('prev-btn') && !item.classList.contains('next-btn')
		)
	};
}

function setTabOverflowMargin(tabs, margin, animate = true) {
	if (!tabs) return;
	tabs.style.transitionProperty = animate ? 'height, margin, padding' : '';
	tabs.style.transitionDuration = animate ? `${animationSpeed}ms` : '';
	tabs.style.marginInlineStart = margin > 0 ? `-${margin}px` : '0px';

	if (animate) {
		window.setTimeout(() => {
			tabs.style.transitionProperty = '';
			tabs.style.transitionDuration = '';
		}, animationSpeed);
	}
}

function updateTabOverflow(container, animate = false) {
	const { tabs, items, tabItems } = getTabOverflowItems(container);
	if (!tabs || !tabItems.length || !container.clientWidth) return;

	const activeItem = tabItems.find((item) => item.querySelector('.nav-link.active')) || tabItems[0];
	const activeIndex = items.indexOf(activeItem);
	const viewWidth = container.clientWidth;
	const totalWidth = tabItems.reduce((width, item) => width + item.clientWidth, 0);
	let activeWidth = 0;

	items.forEach((item, index) => {
		if (index <= activeIndex) activeWidth += item.clientWidth;
	});

	if (totalWidth <= viewWidth) {
		container.classList.remove('overflow-start', 'overflow-end');
		setTabOverflowMargin(tabs, 0, false);
		return;
	}

	const margin = activeWidth >= viewWidth ? activeWidth - viewWidth + 40 : 0;
	setTabOverflowMargin(tabs, margin, animate);
	container.classList.toggle('overflow-end', activeWidth < totalWidth);
	container.classList.toggle('overflow-start', activeWidth >= viewWidth);
}

function handleTabButtonAction(element, direction) {
	const container = element.closest('.nav-tabs-overflow');
	const { tabs, tabItems } = container ? getTabOverflowItems(container) : {};
	if (!container || !tabs || !tabItems.length) return;

	const buttonWidth = 42.5;
	const containerWidth = Math.max(container.clientWidth - buttonWidth * 2, 0);
	const totalWidth = tabItems.reduce((width, item) => width + item.clientWidth, 0);
	const currentMargin = Math.max(0, -(parseFloat(getComputedStyle(tabs).marginInlineStart) || 0));
	let nextMargin = currentMargin;

	if (direction === 'next') {
		nextMargin = Math.min(currentMargin + containerWidth, Math.max(totalWidth - containerWidth, 0));
	} else {
		nextMargin = Math.max(currentMargin - containerWidth, 0);
	}

	setTabOverflowMargin(tabs, nextMargin);
	container.classList.toggle('overflow-start', nextMargin > 0);
	container.classList.toggle('overflow-end', nextMargin < Math.max(totalWidth - containerWidth, 0));
}

export function initializeTabOverflow(root) {
	const tabOverflowContainers = [...root.querySelectorAll('.nav-tabs-overflow')];

	const handleTabClick = (event) => {
		const tabControl = event.target.closest?.('[data-click="prev-tab"], [data-click="next-tab"]');
		if (!tabControl || !root.contains(tabControl)) return;

		event.preventDefault();
		handleTabButtonAction(tabControl, tabControl.dataset.click === 'next-tab' ? 'next' : 'prev');
	};
	const handleTabShown = (event) => {
		const tabLink = event.target.closest?.('.nav-link[data-bs-toggle="tab"]');
		const container = tabLink?.closest('.nav-tabs-overflow');
		if (container && root.contains(container)) updateTabOverflow(container, true);
	};
	const handleResize = () => {
		tabOverflowContainers.forEach((container) => {
			const { tabs } = getTabOverflowItems(container);
			if (tabs) tabs.removeAttribute('style');
			updateTabOverflow(container);
		});
	};

	root.addEventListener('click', handleTabClick);
	root.addEventListener('shown.bs.tab', handleTabShown);
	window.addEventListener('resize', handleResize);
	tabOverflowContainers.forEach((container) => updateTabOverflow(container));

	return () => {
		root.removeEventListener('click', handleTabClick);
		root.removeEventListener('shown.bs.tab', handleTabShown);
		window.removeEventListener('resize', handleResize);
	};
}
